(function () {
  'use strict';

  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMQ.matches) {
    document.documentElement.classList.add('reduce-motion');
    return;
  }

  var prefersFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var supportsTimeline = CSS && CSS.supports && CSS.supports('animation-timeline', 'scroll()');
  document.documentElement.classList.add(supportsTimeline ? 'scroll-timeline' : 'scroll-js');
  document.documentElement.classList.add('londa-motion');

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }
  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  /* ---- Reveal on enter ---- */
  function initReveals() {
    var nodes = document.querySelectorAll(
      '[data-scroll-3d="section"], .scroll-3d-section, .trust-pillar, .explore-card, .brand-beat, .benefit-card, .ba-card, .tl-review, .testimonial-card, .lp-badge, .step-card, .featured-dual__copy, .featured-dual__visual'
    );
    nodes.forEach(function (el) {
      el.classList.add('motion-reveal');
    });
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
    );
    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---- Pointer parallax / 3D tilt ---- */
  function initPointerTilt(root) {
    if (!prefersFine || isMobile) return;
    var stage = root;
    var target =
      root.matches && root.matches('[data-tilt-target]')
        ? root
        : root.querySelector('[data-tilt-target]') ||
          root.querySelector('.scroll-3d-tilt') ||
          root.querySelector('.card-3d') ||
          root;
    var layers = root.querySelectorAll('[data-parallax-layer]');
    var max = parseFloat(root.getAttribute('data-tilt-max') || '14');
    var raf = 0;
    var nx = 0;
    var ny = 0;
    var cx = 0;
    var cy = 0;

    function apply() {
      raf = 0;
      cx = lerp(cx, nx, 0.18);
      cy = lerp(cy, ny, 0.18);
      var rotY = cx * -max;
      var rotX = cy * max * 0.65;
      target.style.transform =
        'perspective(1100px) rotateX(' +
        rotX.toFixed(2) +
        'deg) rotateY(' +
        rotY.toFixed(2) +
        'deg) translateZ(0)';
      layers.forEach(function (layer) {
        var depth = parseFloat(layer.getAttribute('data-parallax-layer') || '1');
        var tx = cx * -22 * depth;
        var ty = cy * -14 * depth;
        var tz = depth * 12;
        layer.style.transform =
          'translate3d(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px,' + tz.toFixed(1) + 'px)';
      });
      if (Math.abs(cx - nx) > 0.001 || Math.abs(cy - ny) > 0.001) {
        raf = requestAnimationFrame(apply);
      }
    }

    stage.addEventListener(
      'pointermove',
      function (e) {
        var rect = stage.getBoundingClientRect();
        nx = (e.clientX - rect.left) / rect.width - 0.5;
        ny = (e.clientY - rect.top) / rect.height - 0.5;
        if (!raf) raf = requestAnimationFrame(apply);
      },
      { passive: true }
    );
    stage.addEventListener('pointerleave', function () {
      nx = 0;
      ny = 0;
      if (!raf) raf = requestAnimationFrame(apply);
    });
  }

  /* ---- Sticky scroll story pin (card tilts through steps) ---- */
  function initScrollPin() {
    var pin = document.querySelector('[data-scroll-pin]');
    if (!pin || isMobile) return;
    var card = pin.querySelector('[data-scroll-pin-card]') || pin.querySelector('.brand-story-pin__card');
    var steps = pin.querySelectorAll('[data-scroll-pin-step]');
    if (!card || !steps.length) return;

    function updatePin() {
      var rect = pin.getBoundingClientRect();
      var total = pin.offsetHeight - window.innerHeight;
      if (total <= 0) return;
      var scrolled = clamp(-rect.top, 0, total);
      var p = scrolled / total;
      var rotY = lerp(-22, 14, p);
      var rotX = lerp(10, -4, p);
      var scale = lerp(0.92, 1.06, p);
      var z = lerp(0, 48, p);
      card.style.transform =
        'perspective(1200px) rotateY(' +
        rotY.toFixed(2) +
        'deg) rotateX(' +
        rotX.toFixed(2) +
        'deg) scale(' +
        scale.toFixed(3) +
        ') translateZ(' +
        z.toFixed(1) +
        'px)';

      var idx = Math.min(steps.length - 1, Math.floor(p * steps.length));
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === idx);
        step.classList.toggle('is-past', i < idx);
      });
      pin.style.setProperty('--pin-progress', p.toFixed(4));
    }

    pin._londaPinUpdate = updatePin;
  }

  /* ---- Scroll-scrubbed hero + section depth ---- */
  function onScroll() {
    var vh = window.innerHeight || 1;

    document.querySelectorAll('[data-scroll-3d="hero"]').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var progress = clamp(1 - (rect.top + rect.height * 0.4) / (vh + rect.height * 0.4), 0, 1);
      el.style.setProperty('--hero-p', progress.toFixed(4));

      var card = el.querySelector('[data-hero-card]') || el.querySelector('.brand-scene__card');
      if (card && !(prefersFine && el.querySelector(':hover'))) {
        var tiltY = lerp(-18, 8, progress);
        var tiltX = lerp(8, -2, progress);
        var z = lerp(40, 8, progress);
        var sc = lerp(1, 0.94, progress);
        card.style.transform =
          'rotateY(' +
          tiltY.toFixed(2) +
          'deg) rotateX(' +
          tiltX.toFixed(2) +
          'deg) translateZ(' +
          z.toFixed(1) +
          'px) scale(' +
          sc.toFixed(3) +
          ')';
      }

      el.querySelectorAll('[data-parallax-scroll]').forEach(function (layer) {
        if (layer.hasAttribute('data-parallax-layer') && prefersFine && !isMobile) return;
        var d = parseFloat(layer.getAttribute('data-parallax-scroll') || '1');
        var y = (1 - progress) * 56 * d;
        var op = clamp(1 - progress * 0.55, 0.35, 1);
        layer.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
        if (layer.classList.contains('brand-hero__layer')) {
          layer.style.opacity = String(op);
        }
      });
    });

    document.querySelectorAll('[data-scroll-3d="card"]').forEach(function (el) {
      if (el.closest('[data-scroll-pin]')) return;
      var rect = el.getBoundingClientRect();
      var mid = rect.top + rect.height * 0.5;
      var p = clamp(1 - mid / vh, 0, 1);
      var tiltY = (0.5 - p) * (isMobile ? 3 : 7);
      var tiltX = (1 - p) * (isMobile ? 1.2 : 2.8);
      el.style.transform =
        'perspective(900px) rotateY(' +
        tiltY.toFixed(2) +
        'deg) rotateX(' +
        tiltX.toFixed(2) +
        'deg) translateZ(' +
        (p * 8).toFixed(1) +
        'px)';
    });

    /* Featured dual band card scrub */
    document.querySelectorAll('[data-scroll-pin-card]').forEach(function (card) {
      if (card.closest('[data-scroll-pin]')) return;
      var wrap = card.closest('.featured-dual') || card.parentElement;
      if (!wrap) return;
      var rect = wrap.getBoundingClientRect();
      var p = clamp(1 - (rect.top + rect.height * 0.3) / (vh + rect.height * 0.3), 0, 1);
      if (prefersFine && wrap.querySelector(':hover')) return;
      var rotY = lerp(-14, 10, p);
      var rotX = lerp(8, -3, p);
      var sc = lerp(0.96, 1.04, p);
      card.style.transform =
        'perspective(1100px) rotateY(' +
        rotY.toFixed(2) +
        'deg) rotateX(' +
        rotX.toFixed(2) +
        'deg) scale(' +
        sc.toFixed(3) +
        ')';
    });

    if (document.querySelector('[data-scroll-pin]') && document.querySelector('[data-scroll-pin]')._londaPinUpdate) {
      document.querySelector('[data-scroll-pin]')._londaPinUpdate();
    }
  }

  var ticking = false;
  function requestTick() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
    }
  }

  function boot() {
    initReveals();
    initScrollPin();

    document.querySelectorAll('[data-pointer-tilt], .card-3d-stage, .product__media-main, .brand-orbit, .brand-scene, .featured-dual__stage').forEach(function (el) {
      if (!el.hasAttribute('data-pointer-tilt')) el.setAttribute('data-pointer-tilt', '');
      initPointerTilt(el);
    });

    document.querySelectorAll('.card-3d').forEach(function (card) {
      var stage = card.closest('.card-3d-stage') || card.parentElement;
      if (stage && !stage.hasAttribute('data-pointer-bound')) {
        stage.setAttribute('data-pointer-bound', '1');
        stage.setAttribute('data-pointer-tilt', '');
        if (!stage.querySelector('[data-tilt-target]')) card.setAttribute('data-tilt-target', '');
        initPointerTilt(stage);
      }
    });

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', function () {
      isMobile = window.matchMedia('(max-width: 749px)').matches;
      requestTick();
    }, { passive: true });
    onScroll();

    document.querySelectorAll('.sticky-buy-bar, .sticky-atc, [data-sticky-atc]').forEach(function (el) {
      el.classList.add('scroll-3d-exempt');
      el.style.transform = 'none';
      el.style.opacity = '1';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
